import { ViewVoucherForm } from './view-voucher-form'

export const ViewVoucherModal = ({
  voucherId,
  onCloseModal,
}: {
  voucherId: number
  onCloseModal: () => void
}) => {
  return <ViewVoucherForm voucherId={voucherId} onCloseModal={onCloseModal} />
}
